import React, { useMemo, useState } from 'react';
import OrderDetailsStepper from '../../../../../../components/OrderDetailsStepper/OrderDetailsStepper';
import FulfilmentSchedule from '../../AdditionalDetails/FulfilmentSchedule';
import PickUpDeliveryDetails from '../../AdditionalDetails/PickUp&DeliveryDetails';
import BaseOrderDetails from '../../../../../../components/BaseOrderDetails/BaseOrderDetails';
import TruckDetailsMap from '../../AdditionalDetails/TruckDetailsMap';
import { AdminOrderProps } from '../../../adminOrder.interface';
import OrderContractDetails from '../../../../../../components/OrderContractDetails/OrderContractDetails';

const TruckConfirmed: React.FC<AdminOrderProps> = (props) => {
	const { selectedOrder, contract, hideMap } = props;
	const [stepperMargin, setStepperMargin] = useState<number>(0);

	const deliveryIncluded = useMemo(() => {
		return selectedOrder?.deliveryIncluded;
	}, [selectedOrder?.deliveryIncluded]);

	const handleWidthChange = (value: number) => {
		setStepperMargin(value);
	};

	const renderInitialSection = () => {
		return deliveryIncluded ? (
			<FulfilmentSchedule
				selectedOrder={selectedOrder}
				step={4}
				deliveryIncluded={deliveryIncluded!}
				simpleOrder={selectedOrder?.trucks?.length === 1}
			/>
		) : (
			<PickUpDeliveryDetails
				selectedOrder={selectedOrder}
				target={selectedOrder?.target}
				isPickUp={true}
				simpleOrder={selectedOrder?.trucks?.length === 1}
			/>
		);
	};

	const showTruckMap = !!deliveryIncluded && !hideMap;

	return (
		<>
			<div style={{ marginBottom: `${stepperMargin}px` }}>
				<OrderDetailsStepper
					current={4}
					simpleOrder={selectedOrder?.trucks?.length === 1}
					order={selectedOrder}
					onWidthChange={handleWidthChange}
				/>
			</div>

			<div className="px-10 pt-7 pb-3.5">
				{contract ? (
					<OrderContractDetails
						selectedOrder={selectedOrder}
						contract={contract}
						target="admin"
					/>
				) : showTruckMap ? (
					<TruckDetailsMap selectedOrder={selectedOrder} />
				) : (
					renderInitialSection()
				)}
			</div>

			{contract && showTruckMap ? (
				<div className="px-10 py-3.5">
					<TruckDetailsMap selectedOrder={selectedOrder} />
				</div>
			) : null}

			{contract ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : showTruckMap ? (
				<div className="px-10 py-3.5">{renderInitialSection()}</div>
			) : null}

			<div className="px-10 py-3.5">
				{deliveryIncluded ? (
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				) : (
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={false}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				)}
			</div>

			<div className="px-10 py-3.5">
				{deliveryIncluded ? (
					<PickUpDeliveryDetails
						selectedOrder={selectedOrder}
						target={selectedOrder?.target}
						isPickUp={false}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				) : (
					<BaseOrderDetails
						selectedOrder={selectedOrder}
						isOpen={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
						deliveryIncluded={deliveryIncluded!}
						target={selectedOrder?.target!}
						contract={contract}
					/>
				)}
			</div>

			<div className="px-10 pb-7 pt-3.5">
				{deliveryIncluded ? (
					<BaseOrderDetails
						selectedOrder={selectedOrder}
						isOpen={true}
						simpleOrder={selectedOrder?.trucks?.length === 1}
						deliveryIncluded={deliveryIncluded!}
						target={selectedOrder?.target!}
						contract={contract}
					/>
				) : (
					<FulfilmentSchedule
						selectedOrder={selectedOrder}
						step={4}
						deliveryIncluded={deliveryIncluded!}
						simpleOrder={selectedOrder?.trucks?.length === 1}
					/>
				)}
			</div>
		</>
	);
};

export default TruckConfirmed;
